import React, { useState } from 'react';
import { GALLERY_IMAGES } from '../data/mockData';
import { ZoomIn } from 'lucide-react';

const ImageMarquee = () => {
  // Duplicate images to create seamless loop
  const images = [...GALLERY_IMAGES, ...GALLERY_IMAGES, ...GALLERY_IMAGES];
  const [pressedImage, setPressedImage] = useState(null);

  const handleStart = (img) => {
    setPressedImage(img);
  };

  const handleEnd = () => {
    setPressedImage(null);
  };

  return (
    <>
        <div className="w-full bg-black/80 border-t border-yellow-500/20 py-6 overflow-hidden relative z-20 backdrop-blur-md select-none">
            <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none"></div>
            <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none"></div>
            
            <div className="flex animate-marquee gap-6 w-max hover:[animation-play-state:paused]">
                {images.map((img, idx) => (
                <div 
                    key={idx} 
                    className="relative w-48 h-32 flex-shrink-0 group cursor-pointer active:scale-95 transition-transform duration-100"
                    onMouseDown={() => handleStart(img)}
                    onMouseUp={handleEnd}
                    onMouseLeave={handleEnd}
                    onTouchStart={() => handleStart(img)}
                    onTouchEnd={handleEnd}
                    onContextMenu={(e) => e.preventDefault()} // Disable right-click/long-press menu
                >
                    {/* Photo Frame Effect */}
                    <div className="absolute inset-0 border-4 border-white/10 group-hover:border-yellow-500 transition-colors duration-300 rounded-lg shadow-lg bg-black/50 overflow-hidden">
                        {/* Image */}
                        <img 
                            src={img} 
                            alt={`Gallery ${idx}`}
                            className="w-full h-full object-cover filter contrast-125 saturate-110 brightness-90"
                            draggable="false"
                        />
                        
                        {/* Gold Shine Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-yellow-500/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        
                        {/* Hint Icon */}
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                            <div className="bg-black/40 backdrop-blur-md rounded-full p-2 text-white/80">
                                <ZoomIn className="w-6 h-6" />
                            </div>
                        </div>
                    </div>
                </div>
                ))}
            </div>
        </div>

        {/* Press & Hold Zoom Overlay */}
        {pressedImage && (
            <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-md pointer-events-none animate-in fade-in duration-200">
                <img 
                    src={pressedImage} 
                    alt="Zoom Preview" 
                    className="max-w-[95vw] max-h-[80vh] object-contain shadow-2xl shadow-yellow-500/20 rounded-xl scale-100 animate-in zoom-in-90 duration-200 filter contrast-125 saturate-110"
                />
                <div className="absolute bottom-10 left-0 right-0 text-center text-white/50 text-sm animate-pulse">
                    Parmağınızı çekince kapanır
                </div>
            </div>
        )}
    </>
  );
};

export default ImageMarquee;
